import { bindActionCreators, AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { connect } from 'react-redux';

import { ActionCreators as AsyncActionCreators, AsyncTasksTypes } from '../../utils/asyncTasks';
import { ActionCreators as BeneficiaryActionCreators } from '../beneficiaries';
import State from '../../app/store/state';
import { hasFeatureAccess } from '../../login/auth';
import { ManagerPermission } from '../../permission-profiles/permission';
import AsyncTasksListView from '../AsyncTasksListView';
import AsyncTasksPage from './AsyncTasksPage';
import { errorAction } from '../../utils/notifications';

const importMapping = {
    individualId: 1,
    caseId: 2,
};

function mapDispatchToProps(dispatch: ThunkDispatch<unknown, void, AnyAction>) {
    return {
        authorizeTask: () => {},
        downloadFile: bindActionCreators(AsyncActionCreators.downloadFile, dispatch),
        loadAsyncTasksList: (page, limit) =>
            dispatch(AsyncActionCreators.loadAsyncTasksList(page, limit, AsyncTasksTypes.IMPORT_BENEFICIARIES_MAPPING)),
        uploadFile: (data: File, dryRun?: boolean, dryRunAsyncTaskId?: string, autoComplete?: boolean) => {
            const params: Record<string, unknown> = {
                data,
                mapping: importMapping,
                startIndex: 2,
                schedule: !dryRun,
            };

            if (dryRun) {
                params.dryRun = true;
            }
            if (dryRunAsyncTaskId) {
                params.dryRunAsyncTaskId = dryRunAsyncTaskId;
            }
            if (autoComplete !== undefined) {
                params.autoComplete = autoComplete;
            }

            return dispatch(BeneficiaryActionCreators.importBeneficiariesMapping(params));
        },
        clearUploadTask: bindActionCreators(BeneficiaryActionCreators.clearUploadTask, dispatch),
        onError: (error: unknown) => dispatch(errorAction(String(error))),
    };
}

function mapStateToProps(state: State) {
    const canImport = hasFeatureAccess(state.auth, ManagerPermission.beneficiaryMappingImport);
    const canDownload = hasFeatureAccess(state.auth, ManagerPermission.beneficiariesDownload);

    return {
        canPark: canImport,
        canDownload: canDownload,
        tasks: state.asyncTasks.asyncTasks[AsyncTasksTypes.IMPORT_BENEFICIARIES_MAPPING],
        authorizedManagerId: state.auth.manager ? state.auth.manager.id : null,
        exampleUploadFile: 'BeneficiaryMappingImportExample.xlsx',
        name: 'Import Beneficiaries Mapping',
        type: AsyncTasksTypes.IMPORT_BENEFICIARIES_MAPPING,
        uploadDescription: 'Upload the Beneficiaries Mapping XLSX file by clicking the button below.',
        exampleLinkTitle: 'See example import file',
        listView: AsyncTasksListView,
        uploadTaskState: state.uploadTaskState,
        shouldRunDryRun: true,
    };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default connect(mapStateToProps, mapDispatchToProps)(AsyncTasksPage as any);
